<div class="bg-ponder-dark min-h-screen w-full overflow-x-hidden flex flex-col items-center"  style="background: linear-gradient(#343346, #1A1922);">
    <div class="flex flex-col items-center sm:items-start sm:flex-row gap-12 sm:gap-4 p-8 pt-12 pb-12 justify-center">
        <div class="flex flex-col gap-4 w-96 text-slate-400 text-sm p-4 rounded-xl bg-ponder-light border border-ponder">
            <div class="text-xl font-bold font-title text-white">
                Ponder <span class="text-foil">Plus+</span> Subscription
            </div>
            <div>
                For <span class="text-xl font-mono text-white ml-2 mr-2">$5.00</span> per month.
            </div>
            <a href="/account/upgrade" class="mt-0 sm:mt-12 hover:text-slate-300">
                ← Back to plan selection
            </a>
        </div>
        <div class="flex flex-col gap-4 justify-center w-96 p-4 rounded-xl bg-ponder-light border border-ponder">
            <div id="payment-element"></div>
            <button id="submit" (click)="onSubmit()" class="bg-ponder-linkhover text-white rounded shadow-sm p-2 hover:bg-ponder-link hover:disabled:bg-ponder-xlight disabled:bg-ponder-xlight disabled:text-faded-20" [disabled]="isProcessing || internalError">
                @if (!isProcessing) {
                    Submit
                } @else {
                    <busy-spin [bright]="true"></busy-spin>
                }
            </button>
            @if (stripeError) {
                <div class="flex flex-col gap-1 text-red-600 text-xs sm:text-sm">
                    <p>{{ (stripeErrorText ? stripeErrorText : "There are errors with your payment information.") }}</p>
                </div>
            }
            @if (internalError) {
                <div class="flex flex-col gap-1 text-red-600 text-xs sm:text-sm">
                    @if (!internalErrorText) {
                        <p>Uh oh, something went wrong!</p>
                        <p>If this issue persists, <a class="text-red-500 hover:text-red-400" href="/about#contact">please contact us.</a></p>
                    } @else {
                        <p>{{ internalErrorText }}</p>
                    }
                </div>
            }
            <div id="error-message"></div>
            <div class="flex flex-row justify-end">
                <a href="https://www.stripe.com">
                    <img src="https://images.pondertcg.com/site/StripeBadge.svg" width="150" height="34">
                </a>
            </div>
            <!--
            <ngx-stripe-elements [stripe]="stripe" [elementsOptions]="stripeElementsOptions">
                <payment-element></payment-element>
            </ngx-stripe-elements>
            -->
        </div>
    </div>
</div>